import React from "react";
import { useRemarkable } from "../../hooks/useRemarkable";
import "./markDownViwer.css";

export const MarkDownViwer = ({ markdown }) => {
    const {html} = useRemarkable(markdown);
    if (!html?.__html) return null;
    return (
        <div className="custom-list-container "
            dangerouslySetInnerHTML={html}
        />
    );
}

